/**
 * Endpoint methods related to Customer Instance
*/

import API from "./Api";

export default {
  /**
   * Creates a new Customer Instance
   */
  async createInstance(form){
    return API.post("/customer/create", form, {
    });
  }
};
